import { LOGIN_REQUESTED, LOGOUT_REQUESTED, RESET_PASSWORD, SEND_PASSWORD_RECOVERY, SET_CONTEXT } from '../constants/actionTypes';

export const login = ( context, username, password ) => {

    return {
        type:    LOGIN_REQUESTED,
        payload: { context, username, password }
    };

};

export const logout = ( context, token ) => {

    return {
        type:    LOGOUT_REQUESTED,
        payload: { context, token }
    };

};

export const resetPassword = ( context, token, password ) => {

    return {
        type:    RESET_PASSWORD,
        payload: { context, token, password }
    };

};

export const sendPasswordRecovery = ( context, username ) => {

    return {
        type:    SEND_PASSWORD_RECOVERY,
        payload: { context, username }
    };

};

export const setContext = context => {

    return {
        type:    SET_CONTEXT,
        payload: { context }
    };

};